import { Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { Socket } from 'ngx-socket-io';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../services/users.service';
import Diamondtable from '../data/diamondlist.json';
@Component({
  selector: 'app-diamondlist',
  templateUrl: './diamondlist.component.html',
  styleUrls: ['./diamondlist.component.scss']
})
export class DiamondlistComponent implements OnInit{

  casino_type:string='LIVECASINO';
  casino_data:any;
  userDetails:any;
  res_msg:any;
  diamondlist: { id: number; name: string; imageurl: string; gameId: string; }[];

  constructor(private route: Router,private socket: Socket,private toastr: ToastrService,public httpClient:UsersService) 
  {
    this.userDetails=JSON.parse(sessionStorage.getItem('userDetails'));
    //this.casino_games(this.casino_type);
    
    
   }

  ngOnInit(): void {
    //this.casino_games(this.casino_type);
    this.diamondlist=Diamondtable;

   }

  spinner(){
    this.route.navigate(['./wheel-spinner']);
  }

//   casino_games(type:string)
//   {
    
//     this.casino_type=type;
//     const data = {
//       gametype:type,
//       username: this.userDetails?.details?.username,
//     };
// console.log(data);
//     this.httpClient.casioPost('providerGames',data).subscribe((res:any) => {
//        console.log(res);
       
//        if(res.error)
//        {
//           this.res_msg=res.message;
//        }
//        else
//        {
//         this.casino_data=[];
//         this.casino_data=res.data.items;
//         console.log(this.casino_data);
        
//        }
//      });
      
//   }

  openDiamond(gameID:string)
  {
    console.log(gameID);
    const data={gameId:gameID}; 
    console.log(data);
    localStorage.setItem('casinoDb',JSON.stringify(data));
    this.route.navigate(['./diamondtable-url']);
   
    
  }
  
  
}
